import { ITranslationEntry } from '../lang';

export const DA: ITranslationEntry = {
  translations: {
    notifications: 'Meddelelser',
    markAllAsRead: 'Markér alle som læst',
    poweredBy: 'Drevet af',
    settings: 'Indstillinger',
  },
  lang: 'da',
};
